import React, {useEffect, useState} from 'react';
import {Link as _RouterLink, useNavigate} from 'react-router-dom';
import {useRoutes} from '../../services/route.service';

import {Button, Flex, HStack, Link} from '@chakra-ui/react';
import {ArrowBack} from '../../components/Icons';
import {StorageService} from '../../services/pt-storage.service';
import {ModuleContext} from '../../types';

export const ModuleBar: React.FC<{
  libraryId: string;
  isPlanned: boolean;
  context: ModuleContext;
  onAddToPlanning: () => void;
  onRemoveFromPlanning: () => void;
  isSelectionPage?: boolean;
  libraryName?: string;
  module?: any;
}> = ({
  libraryId,
  isPlanned,
  onAddToPlanning,
  context,
  onRemoveFromPlanning,
  isSelectionPage,
  libraryName,
  module
}) => {
  const navigate = useNavigate();
  const RouteService = useRoutes();
  const goToLibrary = () => navigate(RouteService.libraryRoute(libraryId));
  const goToPlanning = () => navigate('/planning');

  const inLibCtxt = context === ModuleContext.Library;

  const [librarySelectionLink, setLibSelection] = useState<string>('');

  useEffect(() => {
    setLibSelection(RouteService.librarySelection(StorageService.getVersion()));
  }, [libraryName, isSelectionPage]);
  return (
    <>
      <Flex
        backdropFilter='auto'
        backdropBlur='18px'
        zIndex={1}
        position='sticky'
        mx='32px'
        top={0}
      >
        <Flex
          justifyContent='space-between'
          flex={1}
          p='16px 0'
          borderBottom='1px solid #ccc'
        >
          <Flex flexDir='column' alignItems='flex-start' gap='8px' flex={1}>
            <Flex flex={1} width='100%' padding='16px 0'>
              <Button
                size='md'
                as={_RouterLink}
                variant='link'
                fontSize='16px'
                fontWeight={600}
                color='gray.600'
                gap='8px'
                to={'/library/' + libraryId}
              >
                <ArrowBack />
                Zurück
              </Button>
            </Flex>
            <Flex flex={1} width='100%'>
              <HStack>
                <Link
                  fontSize='14px'
                  as={_RouterLink}
                  to='/library--select--v2'
                >
                  Inhalte /
                </Link>
                <Link
                  fontSize='14px'
                  as={_RouterLink}
                  to={'/library/' + libraryId}
                >
                  {libraryName} /
                </Link>
              </HStack>
            </Flex>
            <Flex flex={1} width='100%' justifyContent='space-between'>
              <Link
                fontSize='20px'
                lineHeight='120%'
                fontWeight={600}
                variant='link'
                as={_RouterLink}
                to={''}
              >
                {module}
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
